const set_exploreId='set_exploreId'
const set_gameType='set_gameType'
const set_visitorId='set_visitorId'
const set_score='set_score'
const set_dev = 'set_dev'
const set_pass1 = 'set_pass1'
const set_pass2 = 'set_pass2'
const set_pass3 = 'set_pass3'
const set_pass4 = 'set_pass4'

export default {

  //设置exploreid
  [set_exploreId](state,data){
	  state.exploreId=data;
  },
  [set_gameType](state,data){
	  state.gameType=data;
  },
  [set_visitorId](state,data){
	  state.visitorId=data;
  },
  [set_score](state,data){
	  state.score=data;
  },
  [set_dev](state,data){
    state.dev=data
  },
  [set_pass1](state,data){
    state.pass1=data
  },
  [set_pass2](state,data){
    state.pass2=data
  },
  [set_pass3](state,data){
    state.pass3=data
  },
  [set_pass4](state,data){
    state.pass4=data
  },

}






// WEBPACK FOOTER //
// ./src/store/mutations.js